import { createAction, props } from '@ngrx/store';
import { ErrorDetails } from 'src/app/models/error-details';
import { UIStyleConfigurationViewDTO } from '../../../data-transfer-objects/configuration/ui-style-configuration-view-dto';

export const getUIStyleConfigurationRequest = createAction('[App] Get UI Style configuration Request');
export const getUIStyleConfigurationDone = createAction('[App] Get UI Style configuration Done', props<{ configuration: UIStyleConfigurationViewDTO }>());
export const getUIStyleConfigurationRequestError = createAction('[App] Get UI Style configuration Request Error', props<{ error: ErrorDetails }>());
